// extracted by mini-css-extract-plugin
module.exports = {"infoItemLabel":"InfoItem_infoItemLabel__2TgBc","infoItemDescription":"InfoItem_infoItemDescription__3UtWM","infoItem":"InfoItem_infoItem__167Sw"};